/**
 * If user enables the disable button and try to add flight,
 * this middleware will restrict the operation
 */

import { REMOVEFLIGHT } from '../flight/actionTypes';

const validationMiddleware = (store) => (next) => (action) => {
    const currentState = store.getState();
    if (action.type === REMOVEFLIGHT || currentState.length < 3) {
        return next(action);
    }
    console.log("Can not add more than 3");
}

export default validationMiddleware;